import reducer from './reducers';

export { default as communityOperations } from './operations';
export { default as communitiesTypes } from './types';
export { default as communitySelectors } from './selectors';

export default reducer;
